const people = [
    // {
    //     id: 1,
    //     // <a href="https://www.flaticon.com/free-icons/no-network" title="no network icons">No network icons created by molmedia - Flaticon</a>
    //     image: require ('./assets/plane-dubairlines.png'),
    //     name: 'dubairlines.com',
    //     description: 'Flights related to Dubai Airports.',
    // },
    // {
    //     id: 2,
    //     image: require ('./assets/racehelmet_mv.png'),
    //     name: 'ticketsdutchgp.com',
    //     description: 'Ticket and raceshop for Dutch Grand Prix racing events.',
    // },
    // {
    //     id: 3,
    //     // image: require ('./assets/logowingsharing.png'),
    //     image: require ('./assets/wingsharing-propellor-4K.png'),
    //     name: 'wingsharing.org',
    //     description: 'Creating a global platform and connecting the world of future aviation.',
    // },
    // {
    //     id: 4,
    //     // <a href="https://www.flaticon.com/free-icons/ipad" title="ipad icons">Ipad icons created by Kiranshastry - Flaticon</a>
    //     image: require ('./assets/digizorger-tablet.png'),
    //     name: 'digizorger.nl',
    //     description: 'Developed for care institutions in the Netherlands.',
    // },
    // {
    //     id: 5,
    //     image: require ('./assets/for-sale.png'),
    //     name: 'flyadultsonly.com',
    //     description: 'Domain FOR SALE.',
    // },

    {
        id: 0,
        image: require ('./assets/google-logo.png'),
        name: '',
        description: '',
    },
    {
        id: 1,
        image: require ('./assets/javascript-logo.png'),
        name: '',
        description: '',
    },
    {
        id: 2,
        image: require ('./assets/reactlogo.png'),
        name: '',
        description: '',
    },
    {
        id: 3,
        image: require ('./assets/java-symbol.png'),
        name: '',
        description: '',
    },
    {
        id: 4,
        image: require ('./assets/spring-boot-logo.png'),
        name: '',
        description: '',
    },
    {
        id: 5,
        image: require ('./assets/maven-logo.png'),
        name: '',
        description: '',
    },
    {
        id: 6,
        image: require ('./assets/logo-postgresql.png'),
        name: '',
        description: '',
    },
    {
        id: 7,
        image: require ('./assets/beckhoff-twincat.png'),
        name: '',
        description: '',
    },
    {
        id: 8,
        image: require ('./assets/logoDCframe.png'),
        name: '',
        description: '',
    },


    // {
    //     id: 10,
    //     image: require ('./assets/csharp-logo.png'),
    //     name: '',
    //     description: '',
    // },
];

export default people;
